import "./Links.scss";

import { useCallback, useEffect } from "react";

import {
  CardIcon,
  DocumentIcon,
  SettingsIcon,
  TagIcon,
} from "../../../../components/icons";
import { useCustomerPortalLink } from "../../../../hooks/reactQueryHooks/useBilling";
import { LinkItem } from "./LinkItem";

interface LinksProps {
  isStripe: boolean;
  organization: string;
}

const azureLinksList = [
  {
    title: "Azure billing ",
    description: "Manage subscription on Azure",
    url: "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/touchcastinc1655995956899.touchcast_cogcache?tab=Overview",
    icon: <SettingsIcon />,
  },
  {
    title: "Pricing",
    description: "View pricing and FAQs",
    url: "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/touchcastinc1655995956899.touchcast_cogcache?tab=PlansAndPrice",
    icon: <TagIcon />,
  },
];

const linksList = [
  {
    title: "Payment methods",
    description: "Add or change payment method",
    url: "",
    icon: <CardIcon />,
  },
  {
    title: "Billing history",
    description: "View past and current invoices",
    url: "",
    icon: <DocumentIcon />,
  },
  {
    title: "Preferences",
    description: "Manage billing information",
    url: "",
    icon: <SettingsIcon />,
  },
  {
    title: "Pricing",
    description: "View pricing and FAQs",
    url: "https://touchcast.com/cogcache-pricing",
    icon: <TagIcon />,
  },
];

const Links: React.FC<LinksProps> = ({ isStripe, organization }) => {
  const { data, refetch } = useCustomerPortalLink(
    organization,
    window.location.href,
  );

  const fetchLink = useCallback(() => {
    if (isStripe) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refetch();
    }
  }, [refetch, isStripe]);

  useEffect(() => {
    fetchLink();
    const interval = setInterval(fetchLink, 2 * 60000);

    return () => clearInterval(interval);
  }, [fetchLink]);

  return (
    <div className="billing-links-container">
      {(isStripe ? linksList : azureLinksList).map((link, i) => {
        return (
          <LinkItem
            {...link}
            url={link.url ? link.url : data?.url || ""}
            key={i}
          />
        );
      })}
    </div>
  );
};

export { Links };
